import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ElasticsearchApiService {
  private readonly baseUrl = '/admin/elasticsearchs';
  constructor(private readonly http: HttpClient) {}
  reprovisionAll(id: number) {
    return this.http.post(`${this.baseUrl}/${id}/reprov-all`, null, {
      responseType: 'text',
    });
  }
}
